import { CButton, CNav, CNavItem, CNavLink } from "@coreui/react"
import { Button, Input, Space } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import AntdTable from "src/components/AntdTable/Table"
import {
  getMailingContentForUser,
  getMailingTypes,
  mailingsContentListAction,
  mailingsInfoListAction,
} from "src/store/Slices/MailingsSlice"
import { DownOutlined, SearchOutlined } from "@ant-design/icons"

const MailingsInfo = ({
  mailingsContent,
  setMailingsContent,
  mnemo,
  columns,
  data,
  setVisible,
  mailingIdForUser,
}) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)
  const [selectedKeys, setSelectedKyes] = useState("")
  const [dataIndex, setDataIndex] = useState("")
  const [sortByIdFrom, setSortByIdFrom] = useState()
  const [sortByIdTo, setSortByIdTo] = useState()

  //STORE
  const mailingsInfoListActionList = useSelector(
    (state) => state.MailingsSlice.mailingsInfoList
  )
  const mailingsInfoListLoading = useSelector(
    (state) => state.MailingsSlice.mailingsInfoListLoading
  )

  const handleReset = (clearFilters) => {
    setPage(1)
    setPageSize(20)
    dispatch(getAbonementsList())
    clearFilters()
    setSortByIdFrom()
    setSortByIdTo()
  }

  const onClickSearchItem = () => {
    setPage(1)
    setPageSize(20)
    dispatch(
      mailingsInfoListAction({
        // from: sortByIdFrom,
        // to: sortByIdTo,
        mailingId: mailingIdForUser.id,
        search: selectedKeys,
        // order:
        // desc:
        // typeId:
      })
    )
  }

  useEffect(() => {}, [mailingsInfoListActionList, mailingIdForUser])

  useEffect(() => {}, [mailingsContent])
  const searchInput = useRef(null)
  // const getColumnSearchProps = (dataIndex, title) => ({
  //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
  //         <div
  //             style={{
  //                 padding: 8,
  //             }}
  //             onKeyDown={(e) => e.stopPropagation()}
  //         >
  //             <div>
  //                 {title !== '№' && <Input
  //                     ref={searchInput}
  //                     placeholder={`Искать ${title}`}
  //                     value={selectedKeys[0]}
  //                     onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
  //                     onPressEnter={() => onClickSearchItem(selectedKeys, dataIndex)}
  //                     style={{
  //                         marginBottom: 8,
  //                         display: 'block',
  //                     }}
  //                 />}
  //                 {(title === '№') &&
  //                     <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
  //                         <Input
  //                             placeholder='От'
  //                             type='number'
  //                             value={sortByIdFrom}
  //                             onChange={e => setSortByIdFrom(e.currentTarget.value)}
  //                         />
  //                         <Input
  //                             placeholder='До'
  //                             type='number'
  //                             value={sortByIdTo}
  //                             onChange={e => setSortByIdTo(e.currentTarget.value)}
  //                         />
  //                     </div>
  //                 }
  //             </div>
  //             <Space>
  //                 <Button
  //                     type="primary"
  //                     onClick={() => onClickSearchItem(selectedKeys, dataIndex)}
  //                     icon={<SearchOutlined />}
  //                     size="small"
  //                     style={{
  //                         width: 90,
  //                     }}
  //                 >
  //                     Искать
  //                 </Button>
  //                 <Button
  //                     onClick={() => {
  //                         if (clearFilters) {
  //                             handleReset(clearFilters)
  //                         }
  //                     }}
  //                     size="small"
  //                     style={{
  //                         width: 90,
  //                     }}
  //                 >
  //                     Сбросить
  //                 </Button>
  //                 <Button
  //                     type="link"
  //                     size="small"
  //                     onClick={() => {
  //                         close();
  //                     }}
  //                 >
  //                     Закрыть
  //                 </Button>
  //             </Space>
  //         </div>
  //     ),
  //     filterIcon: (filtered) => (
  //         <SearchOutlined
  //             style={{
  //                 color: filtered ? '#1677ff' : undefined,
  //             }}
  //         />
  //     ),
  //     onFilter: (value, record) =>
  //         record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  //     onFilterDropdownOpenChange: (visible) => {
  //         if (visible) {
  //             setTimeout(() => searchInput.current?.select(), 100);
  //         }
  //     },
  //     render: (text) =>
  //         text
  // });

  const onClickRowOne = (record) => {
    setMailingsContent(record)
    setVisible({ open: true })
    dispatch(
      getMailingContentForUser({
        mailingId: mailingIdForUser.id,
        userId: record.userId,
      })
    )
  }
  const rowClassName = (record) => {
    return record?.key === mailingsContent?.key ? "" : "selected-row"
  }

  const handleTableChange = (pagination, filters, sorter) => {
    dispatch(
      mailingsInfoListAction({
        // mailingId: mailingsContent.id,
        mailingId: mailingIdForUser.id,
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        from: sortByIdFrom,
        to: sortByIdTo,
        order: sorter?.column?.dataIndex,
        desc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        // typeId: 3,
      })
    )
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }
  // useEffect(() => {
  //     dispatch(getMailingTypes())
  // },[])
  const getColumnSearchProps = () => {}
  const title = () => {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <CNav variant='tabs'>
          <CNavItem>
            <CNavLink style={{ cursor: "pointer" }} active={true}>
              Детали рассылки
            </CNavLink>
          </CNavItem>
        </CNav>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Input
            ref={searchInput}
            placeholder={`№, ФИО, Email`}
            value={selectedKeys}
            onChange={(e) => setSelectedKyes(e.target.value)}
            onPressEnter={() => onClickSearchItem()}
            style={{
              marginRight: 8,
              display: "block",
            }}
          />
          <CButton
            // disabled={!mnemo?.children?.find(el => el.name === 'Таблица клиентов')?.children.find(ele => ele.mnemo === 'insertBtn')}
            size='sm'
            onClick={() => {
              onClickSearchItem()
            }}
            style={{ color: "#fff" }}
          >
            Искать
          </CButton>
        </div>
      </div>
    )
  }
  const addZeroHandler = (_time) => {
    const time = _time.toString()
    if (time.length === 1) {
      return `0${time}`
    }
    return time
  }
  const formatIsoToDate = (_date) => {
    return (
      _date.slice(8, 10) + "." + _date.slice(5, 7) + "." + _date.slice(0, 4)
    )
  }

  const formatIsoToTime = (_date) => {
    const hours = _date.slice(11, 13)
    const minutes = _date.slice(14, 16)
    const seconds = _date.slice(17, 19)
    return (
      addZeroHandler(+hours) +
      ":" +
      addZeroHandler(+minutes) +
      ":" +
      addZeroHandler(+seconds)
    )
  }
  const dataSource = mailingsInfoListActionList?.data?.value?.rows.map(
    (element) => {
      return {
        id: element.id,
        fullname: element.fullname,
        email: element.email,
        phone: element?.phone,
        sendedDate:
          element?.sendedDate &&
          formatIsoToDate(element?.sendedDate) +
            ` ` +
            formatIsoToTime(element?.sendedDate),
        status: element?.status,
        userId: element?.userId,
      }
    }
  )
  return (
    <div>
      {" "}
      <AntdTable
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={page}
        setPage={setPage}
        loading={mailingsInfoListLoading}
        columns={
          mailingsInfoListActionList && [
            ...mailingsInfoListActionList?.data?.value?.columns.map(
              (element) => {
                return {
                  ...element,
                  // ...getColumnSearchProps(element.dataIndex, element.title),
                }
              }
            ),
          ]
        }
        rows={dataSource}
        scroll={{ x: 0, y: 300 }}
        title={title}
        onClickRowOne={onClickRowOne}
        onChange={handleTableChange}
        total={mailingsInfoListActionList?.data?.value?.totalCount}
        rowClassName={rowClassName}
      />
    </div>
  )
}

export default MailingsInfo
